import http from "@/http/aisea/axios";
const resource = "/picture";
const MULTIPART_FORM_DATA_CONTENT_TYPE = "multipart/form-data";

export default {
  // プロフィール系
  addUserPicture(payload, config = {}) {
    const defaultConfig = {
      headers: { "Content-Type": MULTIPART_FORM_DATA_CONTENT_TYPE },
    };
    const mergedConfig = { ...defaultConfig, ...config };
    return http.post(`${resource}/profile`, payload.formData, mergedConfig);
  },

  deleteUserPicture(pictureId) {
    return http.post(`${resource}/profile/${pictureId}`);
  },

  // 船舶系
  addVesselPicture(payload, config = {}) {
    const defaultConfig = {
      headers: { "Content-Type": MULTIPART_FORM_DATA_CONTENT_TYPE },
    };
    const mergedConfig = { ...defaultConfig, ...config };
    return http.post(`${resource}/vessel`, payload.formData, mergedConfig);
  },

  deleteVesselPicture(pictureId) {
    return http.delete(`${resource}/vessel/${pictureId}`);
  },

  // 船舶書類系
  addVesselDocumentPicture(payload, config = {}) {
    const defaultConfig = {
      headers: { "Content-Type": MULTIPART_FORM_DATA_CONTENT_TYPE },
    };
    const mergedConfig = { ...defaultConfig, ...config };
    return http.post(
      `${resource}/vessel/document`,
      payload.formData,
      mergedConfig,
    );
  },

  deleteVesselDocumentPicture(pictureId) {
    return http.post(`${resource}/vessel/document/${pictureId}`);
  },
  // プロット系
  addPlotPicture(payload, config = {}) {
    const defaultConfig = {
      headers: { "Content-Type": MULTIPART_FORM_DATA_CONTENT_TYPE },
    };
    const mergedConfig = { ...defaultConfig, ...config };
    return http.post(`${resource}/plot`, payload.formData, mergedConfig);
  },

  deletePlotPicture(pictureId) {
    return http.post(`${resource}/plot/${pictureId}`);
  },
  // ライセンス系
  fetchLicensePicture(pictureId) {
    return http.get(`${resource}/license/${pictureId}`);
  },

  addLicensePicture(payload, config = {}) {
    const defaultConfig = {
      headers: { "Content-Type": MULTIPART_FORM_DATA_CONTENT_TYPE },
    };
    const mergedConfig = { ...defaultConfig, ...config };
    return http.post(`${resource}/license`, payload.formData, mergedConfig);
  },

  deleteLicensePicture(pictureId) {
    return http.delete(`${resource}/license/${pictureId}`);
  },

  // 共通系
  download(pictureId) {
    return http.get(`${resource}/download/${pictureId}`, {
      responseType: "blob",
    });
  },
};
